import axios from '../../../api/axios'

export const AUDITOR_ENDPOINTS = {
  BASE: "auditors",
};

/**
 * Central error handler
 */
const handleApiError = (error, defaultMessage) => {
  const message = error?.response?.data?.message || error.message || defaultMessage;
  throw new Error(message);
};

/**
 * Create new auditor
 */
export const createAuditor = async (payload) => {
  try {
    const response = await axios.post(AUDITOR_ENDPOINTS.BASE, payload);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to create auditor");
  }
};

/**
 * Update an existing auditor
 */
export const updateAuditor = async (id, payload) => {
  try {
    const url = `${AUDITOR_ENDPOINTS.BASE}/${id}`;
    const response = await axios.put(url, payload);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to update auditor");
  }
};

/**
 * Delete an auditor
 */
export const deleteAuditor = async (id) => {
  try {
    const url = `${AUDITOR_ENDPOINTS.BASE}/${id}`;
    const response = await axios.delete(url);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to delete auditor");
  }
};

/**
 * Fetch all auditors (optionally filter by company_id)
 */
export const getAllAuditors = async (company_id) => {
  try {
    const response = await axios.get(AUDITOR_ENDPOINTS.BASE, {
      params: { company_id },
    });
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to fetch auditors");
  }
};

/**
 * Fetch a single auditor by ID
 */
export const getAuditorById = async (id) => {
  try {
    const url = `${AUDITOR_ENDPOINTS.BASE}/${id}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to fetch auditor");
  }
};